<template lang="html">
     <div>
        <Alerts :alert-type="'alert_homepage'"></Alerts>
        <RovinietaNavigation></RovinietaNavigation>

        <div class="select-vignette">
            <div class="container container-medium purchase-wrapper">
                <div class="text-center pt-2">
                    <Heading :title="$t('buy_vignette')" :routeName="'cart'" :alignment="'text-center'"></Heading>
                    <div><span class="main-text">{{ $tc('step', 1) }}: {{ $t('select_type_of_vehicle') }}</span></div>
                </div>
                <div class="categories" :class="{'mb-0': isLoggedIn && vehicles}">
                    <div class="row">
                        <div class="col-md-3 col-6 item-card" v-for="(item, key) in vignetteCategories" v-bind:key="key">
                            <router-link :to="{name: 'vignette-category', params: {id: item.id}}">
                                <div class="card" dusk="cardelem">
                                    <div class="img-wrapper">
                                        <div class="card-img-top cat-icon" :class="icons[key].icon"></div>
                                    </div>
                                    <div class="card-body text-center align-items-center justify-content-center">
                                        <p class="card-text"><small class="subtitle" v-html="item.desc"></small></p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="isLoggedIn">
            <template v-if="vehicles">
                <div class="container container-small">
                    <div class="text-center">
                        <div class="heading heading-small">
                            {{ $t('or_pay_for') }}
                            <router-link :to="{name: 'my-cars'}">{{ $t('your_vehicles_link') }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="container container-small">
                    <div class="cart-item my-3 p-2" v-for="(item, key) in vehicles" v-if="item.category_vignette" v-bind:key="key">
                        <AddProductForVehicle :vehicle="item" :type="'vignette'"></AddProductForVehicle>
                    </div>
                </div>
                <div class="container container-small text-center" v-if="totalVehiclesPages > 1">
                    <div class="heading heading-small">
                        {{ $t('see_all_your_vehicles') }} <router-link :to="{name: 'my-cars'}">{{ $t('here') }}</router-link>
                    </div>
                </div>
            </template>
        </template>

        <template v-else>
            <div class="login-section">
                <div class="d-flex justify-content-center w-100">
                    <div class="circle">
                        <p class="text">sau</p>
                    </div>
                </div>
                <div class="container container-small">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="main-text text-center">{{ $t('or_go_to_your_account_and_buy') }}</div>
                        </div>
                    </div>
                    <LoginComponent></LoginComponent>
                </div>
            </div>
        </template>

        <section class="section-frequent-questions">
            <div class="container container-small">
                <p class="text-center heading-medium">{{ $t('header_how_does_it_work') }}</p>
                <HowItWorks :withTitle="false" :showBoth="'vignette'"></HowItWorks>
            </div>
        </section>
     </div>
</template>

<script>

import Header from './Header.vue'
import Heading from './snippets/Heading.vue'
import MainNavigation from './MainNavigation.vue'
import RovinietaNavigation from './RovinietaNavigation.vue'
import CartSummary from './order/CartSummary.vue'
import LoginComponent from './authentication/LoginComponent.vue'
import FrequentQuestionComponent from './FrequentQuestionComponent.vue'
import HowItWorks from './HowItWorks.vue'
import AddProductForVehicle from './snippets/AddProductForVehicle.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import Alerts from './snippets/Alerts.vue';

export default {
     name: 'Vignette',
     components: {
          Header,
          MainNavigation,
          RovinietaNavigation,
          CartSummary,
          LoginComponent,
          FrequentQuestionComponent,
          HowItWorks,
          AddProductForVehicle,
          Heading,
          Alerts
     },
     props: {
     },
     computed: {
         ...mapState('vehicles', {
             vehicles: 'vehicles'
         }),

         ...mapState('vignetteCategories', {
             vignetteCategories: 'categories',
             icons: 'icons'
         }),

         ...mapState('auth', [
             'isLoggedIn'
         ]),
     },
     data: function() {
        return {
            count: 5,
            showMoreBtn: true,
            totalVehiclesPages: 0
        }
     },
     mounted() {
         this.init();
     },
     methods: {
        ...mapActions('vignetteCategories', {
            getVignetteCategories: 'getCategories'
        }),

        ...mapActions('vehicles', [
            'getVehicles'
        ]),

        ...mapGetters('auth', [
            'getLoginStatus'
        ]),

        async init() {
            this.loading = true;

            try {
                await this.getVignetteCategories();

                if(this.getLoginStatus()) {
                    let response = await this.getVehicles();
                    this.totalVehiclesPages = response.data.data.vehicles_total;
                }

                this.loading = false;
            } catch (e) {
                console.log(e);
            }
        },

        cartCount() {
            return this.$store.state.cart.length;
        },
        showMore() {
            this.count = 100;
            this.showMoreBtn = false;
        }
     }
}
</script>

<style lang="scss" scoped>

    $lightgrey: lightgrey;
    $green: #59af54;
    $dark: #272D37;

    .purchase-wrapper {
        margin-top: 40px;
    }

    .categories {
        margin-top: 30px;
        margin-bottom: 90px;
    }

    .header-1 {
        margin-top: 8px;
    }
    .select-vignette, .login-section {
        .container {
            p {
                font-size: 17px;
                font-weight: bold;
                text-align: center;
                word-break: break-word;
            }
            .border-right {
                border-right: 1px solid #C7C7C6;
            }
        }
    }

    .section {
        background-color: #FAF9F6;
        padding-bottom: 50px;
        .purchase-wrapper {
            h1 {

                font-weight: 900;
                font-size: 54px;
                margin-top: 87px;
            }
        }
    }
    .card {
        background: transparent;
        border: 1px solid #0F2443;
        padding: 10px 10px;
        &:hover {
            border: 3px solid #0F2443;
            padding: 8px 8px;
        }
    }

    //cardurile cu masinile mele
    .cart-item {
        border-radius: 3px;
        font-size: 14px;
        white-space:nowrap;
        position: relative;
        span {
            font-size: 12px;
            color: $lightgrey;
        }
        .category {
            font-size:12px;
            display: block;
        }
        .no-bottom-margin {
            margin-bottom: 0px;
            text-align: right !important;
        }

        .btn {
            white-space: normal;

            .fas {
                display: block;
            }
        }
    }
    .intra-si-purchase {

        font-size: 22px;
        font-weight: bold;
        margin-bottom: 25px;
    }
    .circle {
        margin: -50px auto;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background-color: #0F2443;
        position: absolute;
        top: 10px;
    }
    .text {
        font-size: 18px;
        font-weight: bold;
        color: white;
        text-align: center;
        padding-top: 24.5px;
    }

    @media only screen and (max-width: 768px) {
        .header-1 {
            margin-top: 0px;
            line-height: 44px;
        }

        .categories {
            margin-top: 10px;
            margin-bottom: 0px;
        }

        .purchase-wrapper {
            margin-bottom: 30px;
        }

        .card {
            padding: 30px 10px 10px 10px;
            &:hover {
                padding:28px 8px 8px 8px;
            }
            .cat-icon {
                height: 35px;
            }
        }
    }
</style>
